import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {WhiteboardService} from '@app/modules/whiteboard/services/whiteboard.service';

@Component({
  selector: 'app-whiteboard',
  templateUrl: './whiteboard.component.html',
  styleUrls: ['./whiteboard.component.scss']
})
export class WhiteboardComponent implements OnInit {

  constructor(
    private whiteboardService: WhiteboardService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  public ngOnInit(): void {
    this.changeDetectorRef.detach();
    this.whiteboardService.init('whiteboard', 'whiteboardWrapper', 'main_');
  }
}
